import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Murat Demir', 159, 6.0, 24, 4.0),
  createData('Emre Veli', 237, 9.0, 37, 4.3),
  createData('Ahmet Bilgili', 262, 16.0, 24, 6.0),
  createData('Hasan Çok', 305, 3.7, 67, 4.3),
  createData('Ali Merkez', 356, 16.0, 49, 3.9),
];

function Activity(props) {
    return (
        <TableContainer component={Paper}>
        <Table sx={{  }} aria-label="simple table" >
            <TableHead>
            <TableRow>
                <TableCell colSpan={2}>{props.title}</TableCell>
                </TableRow>
                </TableHead>
          <TableHead >
            <TableRow>
              <TableCell>Kişi</TableCell>
              <TableCell align="right">Görüşme Kaydı</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
}

export default Activity;